module.exports = __webpack_public_path__ + "assets/img/icon8.e9139082.png";